import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;
const PROJECT_ID = '3yxu1a8a';
const DATASET = 'production';
const API_VERSION = '2023-12-29';

const createSanityClient = () => {
  const config = {
    projectId: PROJECT_ID,
    dataset: DATASET,
    apiVersion: API_VERSION,
    useCdn: true,
    ignoreBrowserTokenWarning: true,
    perspective: 'published',
  };

  console.log('[SanityClient] Initializing with config:', {
    ...config,
    timestamp: new Date().toISOString(),
  });

  return createClient(config);
};

// Create the client instance
const client = createSanityClient();
const builder = imageUrlBuilder(client);

// Export the configured client and image builder
export { client };
export const urlFor = (source) => builder.image(source);

// Simple connection check
export const checkSanityConnection = async () => {
  try {
    await client.fetch('*[_type == "articles"][0]._id');
    console.log('[SanityClient] Connection check successful');
    return true;
  } catch (error) {
    console.error('[SanityClient] Connection check failed:', {
      message: error.message,
      status: error.statusCode,
    });
    return false;
  }
};
